import React from 'react';
import './ContactPage.css';

const ContactPageView = ({ formData, handleChange, handleSubmit, countries }) => {
  return (
    <div className="contact-page">
      <div className="bg-gradient-to-r from-teal-800 to-cyan-900 text-center py-16 px-4">
        <h1 className="text-4xl font-bold text-white mb-2">Contact Us</h1>
        <p className="text-teal-100 max-w-2xl mx-auto">
          Get in touch with our team and let us help you with your mobile app journey
        </p>
      </div>

      <div className="sales-form-container">
        <form onSubmit={handleSubmit} className="sales-contact-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">First Name *</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                placeholder="e.g., John"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="lastName">Last Name *</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                placeholder="Smith"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="companyEmail">Company Email *</label>
            <input
              type="email"
              id="companyEmail"
              name="companyEmail"
              placeholder="name@company.com"
              value={formData.companyEmail}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phoneNumber">Phone Number *</label>
            <input
              type="tel"
              id="phoneNumber"
              name="phoneNumber"
              placeholder="+1 555 555 5656"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="country">Country *</label>
            <select
              id="country"
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
            >
              <option value="">Select...</option>
              {countries.map((country) => (
                <option key={country} value={country}>{country}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="message">What would you like to discuss? *</label>
            <textarea
              id="message"
              name="message"
              placeholder="Tell us about your team and provide some details about a project or process you would like to track."
              value={formData.message}
              onChange={handleChange}
              required
              rows="4"
            ></textarea>
          </div>

          <button type="submit" className="submit-button">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default ContactPageView; 